// src/notification.js
import toast from "react-hot-toast";
import { messaging, getToken, onMessage } from "./firebase";

const requestPermission = async () => {
  if (!("Notification" in window)) {
    return;
  }

  const permission = await Notification.requestPermission();

  if (permission === "granted") {
    if (!messaging) {
      console.warn("[notifications] Messaging is not initialized.");
      return;
    }

    const token = await getToken(messaging, {
      vapidKey:
        "BKoUpfJd5jamKS9Sy5ZJyeQFij5pJsdabJQngGa_PftSad_gYn3yWZ3z8Xox_-i-T9nOvEKbXoO51sRVcJyd8TM",
    });
    if (token) {
      localStorage.setItem("notificationToken", token);
    }
  }
};

export default requestPermission;

const handleForegroundMessages = () => {
  if (!messaging) {
    return;
  }

  onMessage(messaging, (payload) => {
    toast.success(payload?.data?.message || payload?.notification?.title || "New notification");
    // Customize notification handling here
  });
};

export { handleForegroundMessages };
